<template>
  <div class="animate__animated animate__fadeIn text-center header-container">

    <div
      class="text-center"
      v-if="menu.user.logo && (menu.user.use_logo==1)"
    >
      <img
        v-bind:style="{ maxHeight: this.logoSize, maxWidth:'300px' }"
        v-bind:src="
          '/storage/logos/' +
          menu.user.id +
          '/medium/' +
          menu.user.logo +
          '?v=' +
          user.updated_at
        "
        alt="logo"
        class="img-fluid menu-header-logo"
      />
    </div>

    <h1
      v-else
      class="m-name p-0 mb-0  text-center text-capitalize"
      v-bind:style="{ fontFamily: menu.user.font.family}"
    >
      {{ menu.user.name }}
    </h1>
    <div
      v-if="menu.user.type==1"
      class="claim color-1 small cursor-pointer font-weight-bold"
      @click="
                    $router.push({
                      name: 'menuClaim',
                      params: { userSlug: menu.user.slug },
                    })"
    >Claim Menu
    </div>
    <p
      class="
      m-0
      p-0
      pt-2
      small"
      v-if="menu.user.tag_line"
    >
      {{ menu.user.tag_line }}
    </p>
    <div
      class="my-2"
      v-if="this.menu.user.guest_register == 1 && !isMenuOwner && !guest.registered"
      v-on:click="updateDineInIntent(true)"
    >
      <button
        v-on:click="openModal('guestRegister')"
        class="btn btn-sm btn-primary"
      >
        Dine-in Register
      </button>
    </div>
  </div>
</template>

<script>
import menuMixin from "../../../mixins/menuMixin";
export default {
  computed: {
    logoSize: function () {
      let logoSize = "200px";
      if (this.isMobileDevice()) {
        logoSize = "100px";
      }
      return logoSize;
    },
  },
  props: {
    menu: {
      type: Object,
      required: true,
    },
  },
  mixins: [menuMixin],
};
</script>
